import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  const { t } = useTranslation('privacy');
  const { language } = useLanguage();

  return (
    <div className="privacy-policy-page pb-5">
      <SEO 
        title="Privacy Policy - EWANDS Data Protection"
        description="Read EWANDS' privacy policy regarding data collection, usage, and protection. Learn how we handle your information in compliance with Malaysian data protection regulations."
        keywords="EWANDS privacy policy, data protection Malaysia, AI privacy, data security"
        canonicalPath={`/${language}/privacy-policy`}
      />
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <div className="gradient-layer"></div>
          <div className="grid-overlay"></div>
        </div>
        
        <div className="hero-content">
          <div className="container">
            <div className="hero-wrapper">
              <h1 className="hero-quote">
                <span className="quote-highlight">{t('hero.title')}</span>
              </h1>
              <p className="hero-subtitle fade-in" style={{ animationDelay: '0.2s' }}>
                {t('hero.description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="capabilities-grid-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="capability-card-modern fade-in">
                <div className="card-tag">{t('content.tag')}</div>
                <h2 className="capability-title-bold">{t('content.heading')}</h2>
                <div className="card-divider"></div>
                
                <div className="capability-desc-text">
                  <p>
                    {t('content.intro')}
                  </p>

                  <h4 style={{ marginTop: '2rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>
                    {t('content.sections.collection.title')}
                  </h4>
                  <p>
                    {t('content.sections.collection.content')}
                  </p>

                  <h4 style={{ marginTop: '2rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>
                    {t('content.sections.usage.title')}
                  </h4>
                  <p>
                    {t('content.sections.usage.content')}
                  </p>

                  <h4 style={{ marginTop: '2rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>
                    {t('content.sections.security.title')}
                  </h4>
                  <p>
                    {t('content.sections.security.content')}
                  </p>

                  <h4 style={{ marginTop: '2rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>
                    {t('content.sections.contact.title')}
                  </h4>
                  <p>
                    {t('content.sections.contact.content')}{' '}
                    <a href="mailto:sales@ewands.com" style={{ color: 'var(--brand-primary)' }}>
                      sales@ewands.com
                    </a>
                  </p>

                  <p style={{ marginTop: '2rem', fontSize: '0.85rem', color: 'var(--text-muted)' }}>
                    {t('content.lastUpdated')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
